var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loaded && _vm.uncompletedSurveyCount > 0)?_c('div',{staticClass:"my-questionnaire-list-badge"},[_c('b-badge',{staticClass:"float-right number-badge",attrs:{"variant":"danger"}},[_vm._v("\n        "+_vm._s(_vm.uncompletedSurveyCount)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }